import produce from 'immer';
import { Reducer } from 'redux';

import {
  ProposalMetricsActionTypes,
  ProposalMetricsDatesActionTypes,
  ProposalsActionTypes,
} from './action-types';
import {
  initialState,
  initialStateProposalMetric,
  initialStateProposalMetricsDates,
} from './constants';
import {
  ProposalMetricsDatesReducerState,
  ProposalMetricsState,
  ProposalPriceSettingsState as State,
} from './types';

export const proposalsReducer: Reducer<State> = (state = initialState, action): State => {
  switch (action.type) {
    case ProposalsActionTypes.FETCH_PROPOSAL.START:
      return { ...state, proposal: null };

    case ProposalsActionTypes.FETCH_PROPOSAL.SUCCESS:
      return produce(state, (newState: State) => {
        newState.proposal = action.payload;
      });

    case ProposalsActionTypes.FETCH_PROPOSAL.CLEAN_UP:
      return { ...state, proposal: null, assignmentInProgress: false };

    case ProposalsActionTypes.SET_ASSIGMENT_PROGRESS.START:
      return { ...state, assignmentInProgress: true };

    case ProposalsActionTypes.SET_ASSIGMENT_PROGRESS.SUCCESS:
    case ProposalsActionTypes.SET_ASSIGMENT_PROGRESS.FAIL:
      return { ...state, assignmentInProgress: false };

    default:
      return state;
  }
};

export const proposalMetricsReducer: Reducer<ProposalMetricsState> = (
  state = initialStateProposalMetric,
  action,
): ProposalMetricsState => {
  switch (action.type) {
    case ProposalMetricsActionTypes.FETCH_PROPOSAL_METRIC.SUCCESS:
      return produce(state, (newState: ProposalMetricsState) => {
        const { count } = action.payload;

        newState.count = count;
      });
    default:
      return state;
  }
};

export const proposalMetricsDatesReducer: Reducer<ProposalMetricsDatesReducerState> = (
  state = initialStateProposalMetricsDates,
  action,
): ProposalMetricsDatesReducerState => {
  switch (action.type) {
    case ProposalMetricsDatesActionTypes.FETCH_PROPOSAL_METRICS_DATES.SUCCESS:
      return produce(state, (newState: ProposalMetricsDatesReducerState) => {
        const { startDate, endDate } = action.payload;

        newState.startDate = startDate;
        newState.endDate = endDate;
      });
    default:
      return state;
  }
};
